<template>
  <Layout>
    <b-overlay :show="isLoading" rounded="sm">
    <div class="card">
      <div class="card-body">
        <PageHeader :title="title" :items="items" />

        <div class="container">
          <form class="needs-validation" @submit.prevent="formSubmit">
          <div class="card mt-4">
            <div class="row">
              <div class="col-lg-12">
                <div class="form-row big-font">
                  <div class="form-group col-md-12">
                    <label>Escuela profesional</label>
                    <v-select
                            :options="carreras_profesionales"
                            label="carrera"
                            :reduce="c=>c.codigo"
                            v-model="model.grupo_id"
                            :class="{ 'is-invalid': submitted && $v.model.grupo_id.$error }"
                            @input="grupoCambiado"
                    />
                    <div v-if="submitted && $v.model.grupo_id.$error" class="invalid-feedback">
                      <span v-if="!$v.model.grupo_id.required">Este valor es requerido.</span>
                    </div>
                  </div>
                </div>

              </div>
              <div class="col-lg-12">
                <div class="form-row big-font">
                  <div class="form-group col-md-6">
                    <label>Cursos</label>
                    <v-select
                            :options="cursos"
                            label="nombre"
                            :reduce="data=>data.id"
                            v-model="model.curso_id"
                            :class="{ 'is-invalid': submitted && $v.model.curso_id.$error }"

                    />
                    <div v-if="submitted && $v.model.curso_id.$error" class="invalid-feedback">
                      <span v-if="!$v.model.curso_id.required">Este valor es requerido.</span>
                    </div>
                 </div>
                  <div class="form-group col-md-3"  v-show="model.curso_id=='0'">
                    <label>Curso</label>
                    <input
                            class="form-control"
                            v-model="model.curso_otros"
                    />

                  </div>
                  <div class="form-group col-md-2">
                    <label>Grupo</label>
                    <select
                            class="form-control"
                            v-model="model.grupo_curso"
                            :class="{ 'is-invalid': submitted && $v.model.grupo_curso.$error }"
                    >
                      <option value="UNICO">Único</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                      <option value="C">C</option>
                      <option value="D">D</option>
                      <option value="E">E</option>
                    </select>
                    <div v-if="submitted && $v.model.grupo_curso.$error" class="invalid-feedback">
                      <span v-if="!$v.model.grupo_curso.required">Este valor es requerido.</span>
                    </div>
                  </div>
                  <div class="form-group col-md-2">
                    <label>Hora inicio</label>
                    <masked-input
                            id="hora_inicio"
                            mask="11:11"
                            class="form-control"
                            v-model="model.hora_inicio"
                            placeholder="00:00"
                            :class="{ 'is-invalid': submitted && $v.model.hora_inicio.$error }"
                    />
                    <div v-if="submitted && $v.model.hora_inicio.$error" class="invalid-feedback">
                      <span v-if="!$v.model.hora_inicio.required">Este valor es requerido.</span>
                    </div>
                  </div>

                  <div class="form-group col-md-2">
                    <label>Hora final</label>
                    <masked-input
                            id="hora_final"
                            mask="11:11"
                            class="form-control"
                            v-model="model.hora_final"
                            placeholder="00:00"
                            :class="{ 'is-invalid': submitted && $v.model.hora_final.$error }"
                    />
                    <div v-if="submitted && $v.model.hora_final.$error" class="invalid-feedback">
                      <span v-if="!$v.model.hora_final.required">Este valor es requerido.</span>
                    </div>
                  </div>


                </div>



                <div class="form-row big-font">
                  <div class="form-group col-md-12">
                    <label>Tema dictado</label>
                    <input class="form-control"
                           v-model="model.tema"
                           :class="{ 'is-invalid': submitted && $v.model.tema.$error }"/>
                    <div v-if="submitted && $v.model.tema.$error" class="invalid-feedback">
                      <span v-if="!$v.model.tema.required">Este valor es requerido.</span>
                    </div>
                  </div>
                </div>
                <div class="form-row big-font">
                  <div class="form-group col-md-12">
                    <label>Aula virtual (copie el Enlace de la sala virtual utilizada para su sesión)</label>
                    <input class="form-control"  v-model="model.aula_virtual"
                           :class="{ 'is-invalid': submitted && $v.model.aula_virtual.$error }"
                    />
                    <div v-if="submitted && $v.model.aula_virtual.$error" class="invalid-feedback">
                      <span v-if="!$v.model.aula_virtual.required">Este valor es requerido.</span>
                    </div>
                  </div>

                  <div class="form-group col-md-10">
                    <label>Observación</label>
                    <input class="form-control"  v-model="model.observacion"
                    />

                  </div>
                  <div class="form-group col-md-2">
                    <b-button  class="mt-4"  variant="primary" type="submit">
                      Guardar
                    </b-button>
                  </div>
                </div>
              </div>
            </div>

          </div>
          </form>

          <div class="card">
            <div class="row m-5" >
              <table class="table table-bordered">
                <thead>
                <tr>
                  <th>ID</th>
                  <th>Escuela profesional</th>
                  <th>Curso</th>
                  <th>Grupo curso</th>
                  <th>Fecha</th>
                  <th>Hora inicio</th>
                  <th>Hora final</th>
                  <th>Tema</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data, index) in temas" v-bind:key="index">
                  <td>{{data.id}}</td>
                  <td>{{data.grupo}}</td>
                  <td>{{data.curso}}</td>
                  <td>{{data.grupo_curso}}</td>
                  <td>{{data.fecha}}</td>
                  <td>{{data.hora_inicio}}</td>
                  <td>{{data.hora_final}}</td>
                  <td>{{data.tema}}</td>
                </tr>

                </tbody>
              </table>

            </div>

          </div>
        </div>




      </div>
    </div>
    </b-overlay>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import constantes from "../../../config/Constantes";
import {/*email, maxLength, minLength, numeric,*/ required} from "vuelidate/lib/validators";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Asistencia",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
    Layout,
    PageHeader,

  },
  data() {
    return {
      title: "Control de temas",
      items: [
        {
          text: "Control",
          href: "/"
        },
        {
          text: "Temas",
          active: true
        }
      ],
      carreras_profesionales:constantes.carreras_profesionales,

      isLoading: false,
      server: process.env.VUE_APP_BACKEND,

      model:{},
      submitted:false,
      temas:[],
      cursos:[],

    };
  },
  validations: {
    model: {
      grupo_id:{required},
      curso_id:{required},
      grupo_curso:{required},
      hora_inicio:{required},
      hora_final:{required},
      tema:{required},
      aula_virtual:{required},
    }

  },

  methods: {
    grupoCambiado(){
      this.isLoading = true;
      this.axios.get(
              process.env.VUE_APP_BACKEND + "/api/cursos/por-grupo/"+this.model.grupo_id,

      )
              .then((response)=> {
                var otros;
                this.cursos=response.data;
                otros={
                  'id':0,
                  'nombre':"(Otros)"
                };
                this.cursos.push(otros);
                //this.loadItems();
                this.isLoading=false;
              })
              .catch(() => {
                this.$swal("error", "Error", "error");
              })
              .finally(() => {
                //this.isLoading = false;

              });
    },
    formSubmit() {
      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      if(this.$v.$error==false){
        this.guardar();
      }

    },
    guardar(){
      this.$swal
              .fire({
                title: "¿Esta seguro de guardar el tema?",
                text: "-",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#4049D8",
                cancelButtonColor: "#3085d6",
                confirmButtonText: "Si, guardar",
                showLoaderOnConfirm: true
              })
              .then(result => {
                if (result.value) {
                  this.isLoading = true;
                  this.axios.post(
                          process.env.VUE_APP_BACKEND + "/api/temas",
                          {
                            model:this.model
                          }
                  )
                          .then((response)=> {
                            this.$swal("OK", response.data.mensaje, "success");
                          })
                          .catch((ee) => {
                            //console.log(ee.response.data.mensaje);
                            this.$swal("Cuidado", ee.response.data.mensaje, "warning");
                          })
                          .finally(() => {
                            this.isLoading = false;
                            this.loadItems();
                          });
                }
              });
    },
    loadItems()
    {
      this.isLoading = true;
      this.axios.get(
              process.env.VUE_APP_BACKEND + "/api/temas",

      )
              .then((response)=> {
                this.temas=response.data;
              })
              .catch(() => {
                this.$swal("error", "Error", "error");
              })
              .finally(() => {
                this.isLoading = false;

              });
    },


   },
  mounted() {
    this.loadItems();

  }

};
</script>

<style>
.fixtable {
  color: #000000 !important;
}
</style>
